import styled from 'styled-components/macro';

export const ModalWrapper = styled('div')`
  z-index: 2700;
  position: fixed;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.31);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  top: 0px;
  bottom: 0;
`;

export const ModalInner = styled('div')`
  width: 100%;
  overflow: auto;
  max-width: 670px;
  position: relative;
  height: 500px;
  max-height: 500px;
  background: #fff;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.15);
  margin-top: 100px;
  height: auto;
  padding-top: 40px;
  .drop-zone-inner {
    padding: 0 40px 0px;
    * {
      text-align: left;
    }
    .empty {
      margin-bottom: 50px;
      margin-top: 30px;
    }
    .cta,
    .cta * {
      font-size: 22px;
    }
    .dropzone-drop {
      min-height: 200px !important;
    }
  }
`;

export const UploaderView = styled('div')`
  .image-container {
    width: 100%;
    height: auto;
    height: 300px;
    background-size: contain;
    margin: 20px 0;
    background-repeat: no-repeat;
    background-position: center;
    &.center {
      background-position: center;
    }
    &.right {
      background-position: right;
    }
    &.left {
      background-position: left;
    }
    &.contain {
      background-size: contain;
    }
    &.cover {
      background-size: cover;
    }
    &.large {
      height: 800px;
    }
    &.medium {
      height: 500px;
    }
    &.small {
      height: 300px;
    }
  }

  .block__content {
    background-color: transparent !important;
  }

  .block__wrapper {
    table {
      border: 1px solid #eee;
    }
  }
  .block__hover {
    margin-top: 10px !important;
    .block__content {
      line-height: normal;
    }
    .block__wrapper {
      border: 1px solid rgba(0, 0, 0, 0.05);
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05);
    }
  }
  .block__hover--readonly .block__wrapper {
    border: solid 1px transparent;
    box-shadow: none;
    .block__content:before,
    .block__content:after {
      border-top: none;
      border-bottom: none;
    }
    .table-manager-block {
      display: flex;
    }
  }
`;
